import React from 'react';

import EditIcon from '@mui/icons-material/Edit';
import { IconButton } from '@mui/material';

import { Input } from '../../../../components/Input';

type ReadonlyPromptInputProps = {
  value?: string;
  canEdit?: boolean;
  onEdit: () => void;
};

export const ReadonlyPromptInput: React.FC<ReadonlyPromptInputProps> = ({
  value,
  canEdit,
  onEdit,
}) => (
  <div className="relative w-full">
    {canEdit && (
      <IconButton
        onClick={onEdit}
        className="absolute -left-16 top-4 px-3 py-2 text-main border border-[#e5e7eb] border-solid rounded shadow-sm hover:bg-gray-100 focus:outline-none focus:ring-2"
      >
        <EditIcon />
      </IconButton>
    )}
    <Input value={value} disabled readonly multiline />
  </div>
);
